export default __webpack_public_path__ + "static/media/SemiBold.a1cd828f.ttf";